import { actionCreatorsFactory } from '../actions';
import { ListType } from '../constants';
import { textApiGateway } from './api';
import { TextSearchData, ModifiedText, TextSearchModel, TextListMetadata } from './types-store';

export const actionCreators = actionCreatorsFactory<
  TextListMetadata, TextSearchData, ModifiedText, TextSearchModel
>(
  ListType.text,
  textApiGateway
);
